module.exports = __webpack_public_path__ + "img/image-check.5ef2fb3f.svg";